// extracted by mini-css-extract-plugin
export default {"block":"AddBlock_block__tfKhT","length":"AddBlock_length__nbbom","list":"AddBlock_list__Bthrx","item":"AddBlock_item__7Okw9"};